<template>
  <div v-show="theme.presentMode" class="present-mode-container" id="present-mode-container">
    <div @click="toggleShow" class="present-mode-btn btn-closed" v-if="!showBtn">
      <el-icon color="#000">
        <Download/>
      </el-icon>
    </div>
    <div :style="openStyle" @click="toggleShow" class="present-mode-btn btn-open" v-else>
      <el-icon>
        <Download/>
      </el-icon>
    </div>
    <div v-if="showBtn" style="margin-top: 8px" :style="openDownStyle">
      <div @click="show" class="pre-mode-down">
        <div class="pre-mode-down-btn">
          <svg-icon
              color="currentColor"
              class="text m"
              icon-class="view"
          />
        </div>
        <span class="pre-mode-text">
          正常模式
        </span>
      </div>
      <div @click="hide" class="pre-mode-down" style="margin-top: 8px">
        <div class="pre-mode-down-btn">
          <svg-icon
              color="currentColor"
              class="text m"
              icon-class="hide"
          />
        </div>
        <span class="pre-mode-text">
          演示模式
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import {useEventBus} from "@vueuse/core";
import {Download} from "@element-plus/icons-vue";
import {ref} from "vue";

const showBtn = ref(false)
const presentMode = useEventBus('presentMode')
const props = defineProps({
  theme: {
    default() {
      return {}
    }
  }
})
const themeColor = computed(() => {
  return props?.theme?.barColor?.[0]?.color1;
})

function toggleShow() {
  showBtn.value = !showBtn.value
}

const openStyle = computed(() => {
  return {
    background: themeColor.value || '#4D85FF',
    color: '#fff',
  };
})
const openDownStyle = computed(() => {
  return {
    color: themeColor.value || '#4D85FF',
  };
})

function show() {
  localStorage.setItem('presentMode', 'false')
  presentMode.emit(false)
}

function hide() {
  localStorage.setItem('presentMode', 'true')
  presentMode.emit(true)
}
</script>
<style lang="scss">
.present-mode-container {
  position: fixed;
  right: 0;
  top: 88px;
  user-select: none;
  z-index: 999;
}

.present-mode-btn {
  color: #878f95;

}

.present-mode-btn {
  width: 32px;
  height: 32px;
  transform: rotate(90deg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 2px 2px 0 0;
  background: var(---text-6, #FFF);
  box-shadow: 0 2px 10px 0 #00000026;
  cursor: pointer;
  box-sizing: border-box;

  &.btn-open {
    transform: rotate(-90deg);
  }
}

.pre-mode-down {
  background: var(---text-6, #FFF);
  box-shadow: 0 2px 10px 0 #00000026;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 10px;
}

.pre-mode-down-btn {
  font-size: 24px;
}

.pre-mode-text {
  writing-mode: vertical-rl;
  letter-spacing: 4px;
  font-size: 12px;
}
</style>